import React, { useState } from "react";
import { toast } from "react-toastify";
import Modal from "src/components/ui/Modal";
import Button from "src/components/ui/Button";
import InvoiceDocument from "src/components/invoice/InvoiceDocument";
import { generatePDF } from "src/utils/pdfGenerator";
import environment from "src/constants/environments";
import { Loader2, FileDown, Link as LinkIcon } from "lucide-react";

interface GenerateInvoiceModalProps {
  open: boolean;
  onClose: () => void;
  order: any;
  tenant: any;
}

const GenerateInvoiceModal: React.FC<GenerateInvoiceModalProps> = ({
  open,
  onClose,
  order,
  tenant,
}) => {
  const [downloading, setDownloading] = useState(false);
  const invoiceRef = React.useRef<HTMLDivElement>(null);

  const handleDownload = async () => {
    try {
      setDownloading(true);
      await generatePDF(invoiceRef, `invoice-${order.orderId}.pdf`);
      toast.success("Invoice downloaded successfully!");
    } catch (error) {
      toast.error("Failed to generate invoice");
    } finally {
      setDownloading(false);
    }
  };

  const handleCopyLink = async () => {
    const link = `${environment.domainUrl}/app/invoices/${order._id}`;
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Invoice link copied to clipboard!");
    } catch (error) {
      toast.error("Failed to copy link");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Invoice Preview"
      size="3xl"
      footer={
        <>
          <Button
            variant="outline"
            onClick={handleCopyLink}
            className="flex items-center"
          >
            <LinkIcon size={16} className="mr-2" /> Copy Link
          </Button>
          <Button
            onClick={handleDownload}
            disabled={downloading}
            className="bg-indigo-600 text-white flex items-center"
          >
            {downloading ? (
              <>
                <Loader2 size={16} className="animate-spin mr-2" /> Generating...
              </>
            ) : (
              <>
                <FileDown size={16} className="mr-2" /> Download
              </>
            )}
          </Button>
        </>
      }
    >
      <InvoiceDocument ref={invoiceRef} order={order} tenant={tenant} />
    </Modal>
  );
};

export default GenerateInvoiceModal;
